// Anything below 650px will trigger mobile mode
export const MOBILE_MODE_WIDTH_THRESHOLD = 650;

export const TABLET_WIDTH_THRESHOLD = 768;

export const SMALL_DESKTOP_WIDTH_THRESHOLD = 1280;
